import React, { useState } from "react";
import '../css/about.css'
import '../css/home.css'
import '../css/navbar.css'
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink, useNavigate } from "react-router-dom";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailIcon from '@mui/icons-material/Mail';
import { email, phnnumber } from "../data/personalData";
import logoImg from '../images/logo/HE_logo_name.png';

export const Header: React.FC = () => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const navigate = useNavigate();

  const gotoHome = () => {
    setExpanded(false);
    navigate(`/`);
  };

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <>
      <Navbar expanded={expanded} expand="lg" className="navbar" fixed="top" onToggle={() => setExpanded(!expanded)}>
        <Container fluid>
          <Navbar.Brand className="logo navbar m-0" style={{ cursor: "pointer" }} onClick={gotoHome}>
            <img src={logoImg} style={{ boxShadow: "none" }} alt="sitelogo" height="75px" width="150px" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbarScroll" onClick={() => setExpanded(!expanded)} />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="my-2 my-lg-0 text-white m-auto" style={{ maxHeight: '100%' }} navbarScroll>
              <NavLink className='mee' onClick={handleNavClick} to='/'>Home</NavLink>
              <NavLink className='mee' onClick={handleNavClick} to='/about' >About us</NavLink>
              <NavLink className='mee' onClick={handleNavClick} to='/product'>Products</NavLink>
              <NavLink className='mee' onClick={handleNavClick} to='/service'>Service</NavLink>
              <NavLink className='mee' onClick={handleNavClick} to='/contact'>Contact us</NavLink>
            </Nav>
            <div className="headerClass">
              <span className="navcontact contact fw-light m-2">
                <LocalPhoneIcon className="p-1" />
                <a href={`tel:${phnnumber}`} className="phone-number-link contact">
                  <span className="px-1">+91</span>{phnnumber}
                </a>
              </span>
              <a className="contact fw-light m-2" href="mailto:harielectricworks@yahoo.in">
                <MailIcon className="p-1" />{email}
              </a>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar >
    </>
  );
};
